(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-statement-two"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const brandBox = document.querySelector('.brand-statement__box');

    if (!brandBox) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });

    observer.observe(brandBox);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const brandBox = event.target.querySelector('.brand-statement__box');
      if (brandBox) {
        brandBox.classList.add('animate');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-statement"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const brandBox = document.querySelector('.brand-statement__box');

    if (!brandBox) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });

    observer.observe(brandBox);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const brandBox = event.target.querySelector('.brand-statement__box');
      if (brandBox) {
        brandBox.classList.add('animate');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-artists"] && !Shopify.designMode) return;
  try {
    
  class FeaturedArtistsSlider {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector('[data-slider]');
      this.track = section.querySelector('[data-slider-track]');
      this.originalSlides = Array.from(section.querySelectorAll('[data-slide]'));
      this.prevButton = section.querySelector('[data-slider-prev]');
      this.nextButton = section.querySelector('[data-slider-next]');

      this.currentIndex = 0;
      this.isTransitioning = false;

      this.init();
    }

    init() {
      if (this.originalSlides.length === 0) return;

      // Clone slides for infinite loop
      this.setupInfiniteLoop();
      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));

      // Start at first real slide (after clones)
      this.currentIndex = this.originalSlides.length;

      this.updateSlider(false);
      this.setupEventListeners();
    }

    setupInfiniteLoop() {
      // Clone all slides for seamless infinite scrolling
      const clonedBefore = this.originalSlides.map((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('cloned');
        return clone;
      });

      const clonedAfter = this.originalSlides.map((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('cloned');
        return clone;
      });

      // Add clones before original slides
      clonedBefore.forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));

      // Add clones after original slides
      clonedAfter.forEach((clone) => this.track.appendChild(clone));
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      // Touch/Swipe support
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let isDragging = false;

      const handleTouchStart = (e) => {
        startX = e.touches?.[0]?.clientX || e.clientX;
        startY = e.touches?.[0]?.clientY || e.clientY;
        currentX = startX;
        isDragging = true;
      };

      const handleTouchMove = (e) => {
        if (!isDragging) return;
        currentX = e.touches?.[0]?.clientX || e.clientX;
        const currentY = e.touches?.[0]?.clientY || e.clientY;

        // Check if horizontal swipe is dominant
        const diffX = Math.abs(currentX - startX);
        const diffY = Math.abs(currentY - startY);

        if (diffX > diffY && diffX > 10) {
          // Prevent vertical scrolling when swiping horizontally
          e.preventDefault();
        }
      };

      const handleTouchEnd = () => {
        if (!isDragging) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.next() : this.prev();
        }
      };

      this.track.addEventListener('touchstart', handleTouchStart, { passive: true });
      this.track.addEventListener('touchmove', handleTouchMove, { passive: false });
      this.track.addEventListener('touchend', handleTouchEnd, { passive: true });

      // Handle transition end for infinite loop reset
      this.track.addEventListener('transitionend', () => {
        if (this.isTransitioning) {
          this.handleInfiniteLoop();
          this.isTransitioning = false;
        }
      });

      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.handleResize();
        }, 150);
      });
    }

    getSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 749) return 1;
      if (width <= 989) return 2;
      return 3;
    }

    updateSlider(animate = true) {
      if (!this.slides || this.slides.length === 0) return;

      const slideWidth = this.slides[0]?.offsetWidth || 0;
      const gap = window.innerWidth <= 749 ? 24 : 32; // 1.5rem or 2rem
      const offset = -(this.currentIndex * (slideWidth + gap));

      if (!animate) {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(${offset}px)`;

      if (!animate) {
        // Force reflow
        this.track.offsetHeight;
        this.track.style.transition = '';
      }

      // Buttons always enabled for infinite loop
      if (this.prevButton) this.prevButton.disabled = false;
      if (this.nextButton) this.nextButton.disabled = false;
    }

    handleResize() {
      // Recalculate position on resize without animation
      this.updateSlider(false);
    }

    handleInfiniteLoop() {
      const totalSlides = this.originalSlides.length;

      // If we're at the end clones, jump back to the corresponding original slide
      if (this.currentIndex >= totalSlides * 2) {
        const offset = this.currentIndex - totalSlides * 2;
        this.currentIndex = totalSlides + offset;
        this.updateSlider(false);
      }

      // If we're at the start clones, jump to the corresponding original slide
      else if (this.currentIndex < totalSlides) {
        this.currentIndex = totalSlides + this.currentIndex;
        this.updateSlider(false);
      }
    }

    prev() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex--;
      this.updateSlider(true);
    }

    next() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex++;
      this.updateSlider(true);
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    const artistSections = document.querySelectorAll('[data-featured-artists]');
    artistSections.forEach((section) => new FeaturedArtistsSlider(section));

    // Scroll animations
    const heading = document.querySelector('.featured-artists__heading');
    const sliderWrapper = document.querySelector('.featured-artists__slider-wrapper');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('animate');
          }, index * 300);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });

    if (heading) observer.observe(heading);
    if (sliderWrapper) observer.observe(sliderWrapper);
  });

  // Reinitialize on Shopify section load (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const artistSection = event.target.querySelector('[data-featured-artists]');
      if (artistSection) {
        new FeaturedArtistsSlider(artistSection);
        // Trigger animations in theme editor
        const heading = event.target.querySelector('.featured-artists__heading');
        const sliderWrapper = event.target.querySelector('.featured-artists__slider-wrapper');
        if (heading) heading.classList.add('animate');
        if (sliderWrapper) sliderWrapper.classList.add('animate');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-duplicate"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-cards-slider"] && !Shopify.designMode) return;
  try {
    
  class InfoCardsSlider {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector('[data-info-slider]');
      this.track = section.querySelector('[data-info-track]');
      this.slides = Array.from(section.querySelectorAll('[data-info-slide]'));
      this.prevButton = section.querySelector('[data-info-prev]');
      this.nextButton = section.querySelector('[data-info-next]');

      this.currentIndex = 0;
      this.isTransitioning = false;
      this.isMobile = false;

      this.init();
    }

    init() {
      if (this.slides.length === 0) return;

      this.checkMobile();
      this.setupEventListeners();
      this.updateSlider(false);
      this.setupAnimations();
    }

    checkMobile() {
      this.isMobile = window.innerWidth <= 749;
    }

    getSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 749) return 1;
      if (width <= 989) return 2;
      return 3;
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      // Touch/Swipe support
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let isDragging = false;

      const handleTouchStart = (e) => {
        startX = e.touches?.[0]?.clientX || e.clientX;
        startY = e.touches?.[0]?.clientY || e.clientY;
        currentX = startX;
        isDragging = true;
      };

      const handleTouchMove = (e) => {
        if (!isDragging) return;
        currentX = e.touches?.[0]?.clientX || e.clientX;
        const currentY = e.touches?.[0]?.clientY || e.clientY;

        const diffX = Math.abs(currentX - startX);
        const diffY = Math.abs(currentY - startY);

        if (diffX > diffY && diffX > 10) {
          e.preventDefault();
        }
      };

      const handleTouchEnd = () => {
        if (!isDragging) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.next() : this.prev();
        }
      };

      if (this.track) {
        this.track.addEventListener('touchstart', handleTouchStart, { passive: true });
        this.track.addEventListener('touchmove', handleTouchMove, { passive: false });
        this.track.addEventListener('touchend', handleTouchEnd, { passive: true });
      }

      // Handle window resize
      let resizeTimeout;
      let previousSlidesPerView = this.getSlidesPerView();

      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const currentSlidesPerView = this.getSlidesPerView();

          // Reset index if slides per view changed
          if (currentSlidesPerView !== previousSlidesPerView) {
            const maxIndex = Math.max(0, this.slides.length - currentSlidesPerView);
            if (this.currentIndex > maxIndex) {
              this.currentIndex = maxIndex;
            }
            previousSlidesPerView = currentSlidesPerView;
          }

          this.checkMobile();
          this.updateSlider(false);
        }, 150);
      });
    }

    updateSlider(animate = true) {
      if (!this.slides || this.slides.length === 0 || !this.track) {
        if (this.prevButton) this.prevButton.disabled = false;
        if (this.nextButton) this.nextButton.disabled = false;
        return;
      }

      const slidesPerView = this.getSlidesPerView();
      const slideWidth = this.slides[0]?.offsetWidth || 0;
      const gap = this.isMobile ? 24 : 32; // 1.5rem or 2rem
      const offset = -(this.currentIndex * (slideWidth + gap));

      if (!animate) {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(${offset}px)`;

      if (!animate) {
        this.track.offsetHeight;
        this.track.style.transition = '';
      }

      // Calculate max index based on slides per view
      const maxIndex = Math.max(0, this.slides.length - slidesPerView);

      // Update button states
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= maxIndex;
      }
    }

    prev() {
      if (this.isTransitioning || this.currentIndex === 0) return;
      this.isTransitioning = true;
      this.currentIndex--;
      this.updateSlider(true);
      setTimeout(() => { this.isTransitioning = false; }, 500);
    }

    next() {
      const slidesPerView = this.getSlidesPerView();
      const maxIndex = Math.max(0, this.slides.length - slidesPerView);

      if (this.isTransitioning || this.currentIndex >= maxIndex) return;
      this.isTransitioning = true;
      this.currentIndex++;
      this.updateSlider(true);
      setTimeout(() => { this.isTransitioning = false; }, 500);
    }

    setupAnimations() {
      const header = this.section.querySelector('.info-cards-slider__header');
      const wrapper = this.section.querySelector('.info-cards-slider__wrapper');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2,
        rootMargin: '0px 0px -100px 0px'
      });

      if (header) observer.observe(header);
      if (wrapper) observer.observe(wrapper);

      // Animate cards with stagger
      const cardObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('animate');
            }, index * 150);
            cardObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      });

      this.slides.forEach(card => {
        cardObserver.observe(card);
      });
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-info-cards-section]');
    sections.forEach((section) => new InfoCardsSlider(section));
  });

  // Reinitialize on Shopify section load (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-info-cards-section]');
      if (section) {
        new InfoCardsSlider(section);

        // Trigger animations in theme editor
        const header = section.querySelector('.info-cards-slider__header');
        const wrapper = section.querySelector('.info-cards-slider__wrapper');
        const cards = section.querySelectorAll('.info-card');

        if (header) header.classList.add('animate');
        if (wrapper) wrapper.classList.add('animate');
        cards.forEach(card => card.classList.add('animate'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-collection-slider"] && !Shopify.designMode) return;
  try {
    
  async function openCartDrawer() {
    try {
      const cart = await (await fetch('/cart.js')).json();

      const cartBubble = document.querySelector('.cart-bubble');
      const cartBubbleCount = document.querySelector('[data-testid="cart-bubble"]');
      const cartBubbleText = document.querySelector('#cart-bubble-text .visually-hidden');

      if (cartBubbleCount) {
        cartBubbleCount.textContent = cart.item_count;
        if (cart.item_count > 0) cartBubbleCount.classList.remove('hidden');
      }
      if (cartBubble && cart.item_count > 0) cartBubble.classList.remove('visually-hidden');
      if (cartBubbleText) cartBubbleText.textContent = `Cart count: ${cart.item_count}`;

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } })
      );

      const sectionId = document.querySelector('cart-items-component')?.dataset?.sectionId || 'cart-drawer';
      const sectionHTML = await (await fetch(`/?section_id=${sectionId}`)).text();
      const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const newCartItems = doc.querySelector('cart-items-component');
      const currentCartItems = document.querySelector('cart-items-component');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;

        const newHeading = doc.querySelector('#cart-drawer-heading');
        const currentHeading = document.querySelector('#cart-drawer-heading');
        if (newHeading && currentHeading) currentHeading.textContent = newHeading.textContent;

        const newShippingBar = doc.querySelector('.custom-shipping-bar');
        const currentShippingBar = document.querySelector('.custom-shipping-bar');
        if (newShippingBar && currentShippingBar) currentShippingBar.innerHTML = newShippingBar.innerHTML;

        const dialog = document.querySelector('.cart-drawer__dialog');
        if (dialog) dialog.classList.toggle('cart-drawer--empty', cart.item_count === 0);
      }

      const trigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('cart-drawer-component button');
      if (trigger) trigger.click();
    } catch (err) {
      console.error('Error updating cart:', err);
    }
  }

  async function addToCart(variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    if (!response.ok) throw new Error('Failed to add to cart');
    return response.json();
  }

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-latest-collection] [data-buy-now]');
    if (!button) return;
    e.preventDefault();

    const originalText = button.textContent;
    try {
      button.disabled = true;
      button.textContent = 'Just a sec...';
      await addToCart(button.dataset.variantId);
      window.location.href = '/checkout';
    } catch (error) {
      console.error('Buy now error:', error);
      button.textContent = 'Try again';
      setTimeout(() => { button.textContent = originalText; button.disabled = false; }, 2000);
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-latest-collection] .product-card__form');
    if (!form) return;
    e.preventDefault();

    const button = form.querySelector('.product-card__button');
    const originalText = button.textContent;
    const formData = new FormData(form);

    try {
      button.disabled = true;
      button.textContent = 'Adding...';
      await addToCart(formData.get('id'));
      button.textContent = 'Added';
      openCartDrawer();
      setTimeout(() => { button.textContent = originalText; button.disabled = false; }, 800);
    } catch (error) {
      console.error('Add to cart error:', error);
      button.textContent = 'Try again';
      setTimeout(() => { button.textContent = originalText; button.disabled = false; }, 2000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection intro "Read more" (only shown when the 2-line clamp actually cuts text)
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-mp-intro]').forEach((intro) => {
      const text = intro.querySelector('.mp-intro__text');
      const btn = intro.querySelector('.mp-intro__toggle');
      if (!text || !btn) return;
      if (text.scrollHeight > text.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', () => {
        const open = intro.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  });

  // Filter functionality
  document.addEventListener('DOMContentLoaded', () => {
    const pieceCountFilter = document.getElementById('filter-piece-count');
    const puzzleTypeFilter = document.getElementById('filter-puzzle-type');
    const artistFilter = document.getElementById('filter-artist');
    const sortBySelect = document.getElementById('sort-by');
    const sortByMobile = document.getElementById('sort-by-mobile');
    const filterDrawer = document.getElementById('filter-drawer');
    const filterBtn = document.getElementById('mobile-filter-btn');
    const closeFilterBtn = document.getElementById('close-filter-drawer');
    const filterOverlay = document.getElementById('filter-overlay');
    const applyFiltersBtn = document.getElementById('apply-filters-btn');
    const clearFiltersBtn = document.getElementById('clear-filters-btn');

    // Drawer filter elements
    const pieceCountDrawer = document.getElementById('filter-piece-count-drawer');
    const puzzleTypeDrawer = document.getElementById('filter-puzzle-type-drawer');
    const artistDrawer = document.getElementById('filter-artist-drawer');

    const populateArtistFilter = () => {
      const products = document.querySelectorAll('.custom-product-card');
      const artists = new Set();

      products.forEach(product => {
        const title = product.querySelector('.custom-product-card__title-link')?.textContent.trim();
        if (title) {
          const match = title.match(/artwork\s+by\s+(.+)/i);
          if (match) {
            const artist = match[1].trim();
            artists.add(artist);
          }
        }
      });

      artists.forEach(artist => {
        const option = document.createElement('option');
        option.value = artist.toLowerCase();
        option.textContent = artist;
        artistFilter.appendChild(option);

        const drawerOption = document.createElement('option');
        drawerOption.value = artist.toLowerCase();
        drawerOption.textContent = artist;
        artistDrawer.appendChild(drawerOption);
      });
    };

    populateArtistFilter();

    // Sync drawer filters with desktop filters
    const syncDrawerToDesktop = () => {
      pieceCountFilter.value = pieceCountDrawer.value;
      puzzleTypeFilter.value = puzzleTypeDrawer.value;
      artistFilter.value = artistDrawer.value;
    };

    const syncDesktopToDrawer = () => {
      pieceCountDrawer.value = pieceCountFilter.value;
      puzzleTypeDrawer.value = puzzleTypeFilter.value;
      artistDrawer.value = artistFilter.value;
    };

    const applyFilters = () => {
      const pieceCount = pieceCountFilter.value;
      const puzzleType = puzzleTypeFilter.value;
      const artist = artistFilter.value;

      console.log('--- Applying Filters ---');
      console.log('Piece Count Filter Value:', pieceCount || '(none)');
      console.log('Puzzle Type Filter Value:', puzzleType || '(none)');
      console.log('Artist Filter Value:', artist || '(none)');

      const products = document.querySelectorAll('.custom-product-card');

      products.forEach(product => {
        let show = true;

        // Get data attributes (fallback to empty string)
        const productPieceCount = product.dataset.pieceCount || '';
        const productPuzzleType = product.dataset.puzzleType || '';
        const productTags = product.dataset.tags || '';

        // Get full product title text
        const titleEl = product.querySelector('.custom-product-card__title-link');
        const titleText = titleEl?.textContent.trim() || '';

        // Extract artist from title
        const artistMatch = titleText.match(/artwork\s+by\s+(.+)/i);
        const productArtist = artistMatch ? artistMatch[1].trim().toLowerCase() : '';

        console.log('Product Title:', titleText);

        // --- Piece Count Filter ---
        // Check data attribute, tags, AND product title for "500" or "1000"
        if (pieceCount) {
          const inDataAttr = productPieceCount.includes(pieceCount);
          const inTags = productTags.includes(pieceCount);
          const inTitle = titleText.includes(pieceCount);

          console.log(
            `  Piece count check for "${pieceCount}": dataAttr=${inDataAttr}, tags=${inTags}, title=${inTitle}`
          );

          if (!inDataAttr && !inTags && !inTitle) {
            show = false;
          }
        }

        // --- Puzzle Type Filter ---
        // Check data attribute, tags, AND title for puzzle type keyword
        if (puzzleType) {
          const inDataAttr = productPuzzleType === puzzleType;
          const inTags = productTags.toLowerCase().includes(puzzleType.toLowerCase());
          const inTitle = titleText.toLowerCase().includes(puzzleType.toLowerCase());

          console.log(
            `  Puzzle type check for "${puzzleType}": dataAttr=${inDataAttr}, tags=${inTags}, title=${inTitle}`
          );

          if (!inDataAttr && !inTags && !inTitle) {
            show = false;
          }
        }

        // --- Artist Filter (unchanged - working fine) ---
        if (artist && productArtist !== artist.toLowerCase()) {
          show = false;
        }

        console.log(`  → Show: ${show}`);
        product.style.display = show ? '' : 'none';
      });

      syncDesktopToDrawer();
    };

    // Handle sort
    const handleSort = (select) => {
      const sortValue = select.value;
      if (!sortValue) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      window.location.href = url.toString();
    };

    // Set current sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortBySelect.value = currentSort;
      sortByMobile.value = currentSort;
    }

    // Mobile filter drawer functions
    const openFilterDrawer = () => {
      syncDesktopToDrawer();
      filterDrawer?.classList.add('is-open');
      filterOverlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    };

    const closeFilterDrawer = () => {
      filterDrawer?.classList.remove('is-open');
      filterOverlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
    };

    const clearFilters = () => {
      pieceCountFilter.value = '';
      puzzleTypeFilter.value = '';
      artistFilter.value = '';
      pieceCountDrawer.value = '';
      puzzleTypeDrawer.value = '';
      artistDrawer.value = '';
      applyFilters();
    };

    // Event listeners with console logs on change
    pieceCountFilter?.addEventListener('change', () => {
      console.log('🔢 Piece Count dropdown changed to:', pieceCountFilter.value || '(cleared)');
      applyFilters();
    });

    puzzleTypeFilter?.addEventListener('change', () => {
      console.log('🧩 Puzzle Type dropdown changed to:', puzzleTypeFilter.value || '(cleared)');
      applyFilters();
    });

    // Artist stays as-is (working fine)
    artistFilter?.addEventListener('change', applyFilters);

    sortBySelect?.addEventListener('change', () => handleSort(sortBySelect));
    sortByMobile?.addEventListener('change', () => handleSort(sortByMobile));

    // Mobile filter drawer events
    filterBtn?.addEventListener('click', openFilterDrawer);
    closeFilterBtn?.addEventListener('click', closeFilterDrawer);
    filterOverlay?.addEventListener('click', closeFilterDrawer);

    applyFiltersBtn?.addEventListener('click', () => {
      syncDrawerToDesktop();
      applyFilters();
      closeFilterDrawer();
    });

    clearFiltersBtn?.addEventListener('click', clearFilters);

    // Quick-link chips: /collections/all-product?pieces=500|1000 pre-selects the piece-count filter
    const piecesParam = urlParams.get('pieces');
    if (piecesParam === '500' || piecesParam === '1000') {
      pieceCountFilter.value = piecesParam;
      applyFilters();
    }
  });

  // Add to Cart functionality
  document.addEventListener('DOMContentLoaded', () => {

    async function openCartDrawer() {
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const cartBubble = document.querySelector('.cart-bubble');
        const cartBubbleCount = document.querySelector('[data-testid="cart-bubble"]');
        const cartBubbleText = document.querySelector('#cart-bubble-text .visually-hidden');

        if (cartBubbleCount) {
          cartBubbleCount.textContent = cart.item_count;
          if (cart.item_count > 0) {
            cartBubbleCount.classList.remove('hidden');
          }
        }

        if (cartBubble && cart.item_count > 0) {
          cartBubble.classList.remove('visually-hidden');
        }

        if (cartBubbleText) {
          cartBubbleText.textContent = `Cart count: ${cart.item_count}`;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart },
          })
        );

        const sectionId =
          document.querySelector('cart-items-component')?.dataset?.sectionId || 'cart-drawer';
        const sectionResponse = await fetch(`/?section_id=${sectionId}`);
        const sectionHTML = await sectionResponse.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHTML, 'text/html');

        const newCartItems = doc.querySelector('cart-items-component');
        const currentCartItems = document.querySelector('cart-items-component');

        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;

          const newHeading = doc.querySelector('#cart-drawer-heading');
          const currentHeading = document.querySelector('#cart-drawer-heading');
          if (newHeading && currentHeading) {
            currentHeading.textContent = newHeading.textContent;
          }

          const newShippingBar = doc.querySelector('.custom-shipping-bar');
          const currentShippingBar = document.querySelector('.custom-shipping-bar');
          if (newShippingBar && currentShippingBar) {
            currentShippingBar.innerHTML = newShippingBar.innerHTML;
          }

          const cartDrawerDialog = document.querySelector('.cart-drawer__dialog');
          if (cartDrawerDialog) {
            if (cart.item_count === 0) {
              cartDrawerDialog.classList.add('cart-drawer--empty');
            } else {
              cartDrawerDialog.classList.remove('cart-drawer--empty');
            }
          }
        }

        const cartDrawerTrigger =
          document.querySelector('[data-testid="cart-drawer-trigger"]') ||
          document.querySelector('cart-drawer-component button');
        if (cartDrawerTrigger) {
          cartDrawerTrigger.click();
        }
      } catch (err) {
        console.error('Error updating cart:', err);
      }
    }

    const productForms = document.querySelectorAll('.custom-product-card__form');

    const addProductToCart = async (form) => {
      const formData = new FormData(form);
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: formData.get('id'),
          quantity: 1,
        }),
      });

      if (!response.ok) throw new Error('Failed to add to cart');
    };

    productForms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const addToCartButton = form.querySelector('.custom-product-card__add-to-cart');
        const buyNowButton = form.querySelector('.custom-product-card__buy-now');
        const originalText = addToCartButton.textContent;

        try {
          addToCartButton.disabled = true;
          buyNowButton.disabled = true;
          addToCartButton.textContent = 'ADDING...';

          await addProductToCart(form);

          addToCartButton.textContent = 'ADDED!';
          openCartDrawer();

          setTimeout(() => {
            addToCartButton.textContent = originalText;
            addToCartButton.disabled = false;
            buyNowButton.disabled = false;
          }, 800);

        } catch (error) {
          console.error('Add to cart error:', error);
          addToCartButton.textContent = 'ERROR';
          setTimeout(() => {
            addToCartButton.textContent = originalText;
            addToCartButton.disabled = false;
            buyNowButton.disabled = false;
          }, 2000);
        }
      });

      const buyNowButton = form.querySelector('.custom-product-card__buy-now');
      buyNowButton.addEventListener('click', async () => {
        const addToCartButton = form.querySelector('.custom-product-card__add-to-cart');
        const originalText = buyNowButton.textContent;

        try {
          addToCartButton.disabled = true;
          buyNowButton.disabled = true;
          buyNowButton.textContent = 'CHECKING OUT...';
          await addProductToCart(form);
          const checkoutUrl = new URL(form.action);
          checkoutUrl.pathname = checkoutUrl.pathname.replace(/\/cart\/add$/, '/checkout');
          checkoutUrl.search = '';
          window.location.assign(checkoutUrl.toString());
        } catch (error) {
          console.error('Buy now error:', error);
          buyNowButton.textContent = 'TRY AGAIN';
          setTimeout(() => {
            buyNowButton.textContent = originalText;
            addToCartButton.disabled = false;
            buyNowButton.disabled = false;
          }, 2000);
        }
      });
    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pieces-over-pixels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const elements = {
      heading: document.querySelector('.pop-heading'),
      subheading: document.querySelector('.pop-subheading'),
      media: document.querySelector('.pop-media'),
      features: document.querySelector('.pop-features')
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delays = {
            '.pop-heading': 0,
            '.pop-subheading': 200,
            '.pop-media': 400,
            '.pop-features': 400
          };

          const selector = Array.from(entry.target.classList).find(cls =>
            Object.keys(delays).some(key => key.includes(cls))
          );

          const delay = selector ? delays[`.${selector}`] || 0 : 0;

          setTimeout(() => {
            entry.target.classList.add('animate');
          }, delay);

          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px'
    });

    Object.values(elements).forEach(el => {
      if (el) observer.observe(el);
    });

    // Slider functionality for mobile - swipe only
    const initSlider = () => {
      const slider = document.querySelector('.pop-features-grid');

      if (!slider || window.innerWidth > 768) return;

      // Touch swipe support already handled by CSS scroll-snap
      // No additional JavaScript needed for basic swipe functionality
    };

    initSlider();
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const elements = [
        '.pop-heading',
        '.pop-subheading',
        '.pop-media',
        '.pop-features'
      ];

      elements.forEach(selector => {
        const el = event.target.querySelector(selector);
        if (el) el.classList.add('animate');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puzzle-collection"] && !Shopify.designMode) return;
  try {
    
  class PuzzleCollection {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector('[data-puzzle-slider]');
      this.track = section.querySelector('[data-puzzle-track]');
      this.cards = Array.from(section.querySelectorAll('[data-puzzle-card]'));
      this.slides = Array.from(section.querySelectorAll('[data-puzzle-slide]'));
      this.prevButton = section.querySelector('[data-puzzle-prev]');
      this.nextButton = section.querySelector('[data-puzzle-next]');

      this.currentIndex = 0;
      this.isTransitioning = false;
      this.isMobile = false;

      this.init();
    }

    init() {
      this.setupHeaderAnimation();
      this.setupScrollAnimation();
      this.setupParallaxEffect();
      this.setupSlider();
    }

    setupSlider() {
      if (this.slides.length === 0) return;

      this.checkMobile();
      this.setupSliderEventListeners();
      this.updateSlider(false);
    }

    checkMobile() {
      this.isMobile = window.innerWidth <= 749;

      if (!this.isMobile && this.track) {
        this.track.style.transform = '';
        this.currentIndex = 0;
      }
    }

    setupSliderEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      // Touch/Swipe support
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let isDragging = false;

      const handleTouchStart = (e) => {
        if (!this.isMobile) return;
        startX = e.touches?.[0]?.clientX || e.clientX;
        startY = e.touches?.[0]?.clientY || e.clientY;
        currentX = startX;
        isDragging = true;
      };

      const handleTouchMove = (e) => {
        if (!isDragging || !this.isMobile) return;
        currentX = e.touches?.[0]?.clientX || e.clientX;
        const currentY = e.touches?.[0]?.clientY || e.clientY;

        const diffX = Math.abs(currentX - startX);
        const diffY = Math.abs(currentY - startY);

        if (diffX > diffY && diffX > 10) {
          e.preventDefault();
        }
      };

      const handleTouchEnd = () => {
        if (!isDragging || !this.isMobile) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.next() : this.prev();
        }
      };

      if (this.track) {
        this.track.addEventListener('touchstart', handleTouchStart, { passive: true });
        this.track.addEventListener('touchmove', handleTouchMove, { passive: false });
        this.track.addEventListener('touchend', handleTouchEnd, { passive: true });
      }

      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.checkMobile();
          this.updateSlider(false);
        }, 150);
      });
    }

    updateSlider(animate = true) {
      if (!this.isMobile || !this.slides || this.slides.length === 0 || !this.track) {
        if (this.prevButton) this.prevButton.disabled = false;
        if (this.nextButton) this.nextButton.disabled = false;
        return;
      }

      const slideWidth = this.slides[0]?.offsetWidth || 0;
      const gap = 32; // 2rem
      const offset = -(this.currentIndex * (slideWidth + gap));

      if (!animate) {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(${offset}px)`;

      if (!animate) {
        this.track.offsetHeight;
        this.track.style.transition = '';
      }

      // Update button states
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= this.slides.length - 1;
      }
    }

    prev() {
      if (this.isTransitioning || this.currentIndex === 0) return;
      this.isTransitioning = true;
      this.currentIndex--;
      this.updateSlider(true);
      setTimeout(() => { this.isTransitioning = false; }, 500);
    }

    next() {
      if (this.isTransitioning || this.currentIndex >= this.slides.length - 1) return;
      this.isTransitioning = true;
      this.currentIndex++;
      this.updateSlider(true);
      setTimeout(() => { this.isTransitioning = false; }, 500);
    }

    setupHeaderAnimation() {
      const header = this.section.querySelector('.puzzle-collection__header');
      if (!header) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2,
        rootMargin: '0px 0px -100px 0px'
      });

      observer.observe(header);
    }

    setupScrollAnimation() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px',
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
            }, index * 150);
          }
        });
      }, observerOptions);

      this.cards.forEach((card) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
        observer.observe(card);
      });
    }

    setupParallaxEffect() {
      this.cards.forEach((card) => {
        const pieces = card.querySelectorAll('.puzzle-piece');

        card.addEventListener('mousemove', (e) => {
          const rect = card.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width;
          const y = (e.clientY - rect.top) / rect.height;

          pieces.forEach((piece) => {
            const speed = parseFloat(piece.dataset.floatSpeed) || 1;
            const moveX = (x - 0.5) * 20 * speed;
            const moveY = (y - 0.5) * 20 * speed;

            piece.style.transform = `translate(${moveX}px, ${moveY}px)`;
          });
        });

        card.addEventListener('mouseleave', () => {
          pieces.forEach((piece) => {
            piece.style.transform = '';
          });
        });
      });
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    const puzzleSections = document.querySelectorAll('.puzzle-collection');
    puzzleSections.forEach((section) => new PuzzleCollection(section));
  });

  // Reinitialize on Shopify section load (theme editor)
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.puzzle-collection')) {
        new PuzzleCollection(event.target.querySelector('.puzzle-collection'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
